import { homeSecurityPortalApi } from 'data/axios';
import {
  TAddCameraPurchaseInfoRequest,
  TDeletedDeviceType,
  TDeviceResponseType,
  TPromotionSkipType,
  TProductType
} from 'typings';
import { ApiResponse } from './HttpRequest';
import { ATLAS_ENDPOINTS } from './endpoints';

export async function getAllDeviceInSpace(
  spaceId: string
): Promise<ApiResponse<{ items: TDeviceResponseType[] }>> {
  const response = await homeSecurityPortalApi.get(
    ATLAS_ENDPOINTS.DEVICES_IN_SPACE(spaceId)
  );
  console.log('getAllDeviceBySpaceId', response);
  return response;
}

export async function getDeletedDevicesInSpace(
  spaceId: string
): Promise<ApiResponse<{ items: TDeletedDeviceType[] }>> {
  return homeSecurityPortalApi.get(
    ATLAS_ENDPOINTS.DELETED_DEVICES_IN_SPACE(spaceId)
  );
}

export async function getPromotionSkips(
  spaceId: string,
  productType: TProductType
): Promise<ApiResponse<{ items: TPromotionSkipType[] }>> {
  return homeSecurityPortalApi.get(
    ATLAS_ENDPOINTS.PROMOTION_SKIPS_IN_SPACE(spaceId, productType)
  );
}

export async function postPromotionSkip(
  spaceId: string,
  productType: TProductType
) {
  try {
    const response = await homeSecurityPortalApi.post(
      ATLAS_ENDPOINTS.PROMOTION_SKIPS_IN_SPACE(spaceId),
      { product_type: productType }
    );
    return response;
  } catch (error) {
    console.error('Error recording promotion skip:', error);
    throw error;
  }
}

export const getAllMarketplaces = async (spaceId: string, deviceId: string) => {
  const response = await homeSecurityPortalApi.get(
    ATLAS_ENDPOINTS.GET_ALL_MARKET_PLACE(spaceId, deviceId)
  );
  return response;
};

export const addCameraPurchaseInfo = async (
  spaceId: string,
  deviceId: string,
  data: TAddCameraPurchaseInfoRequest
) => {
  try {
    const response = await homeSecurityPortalApi.post(
      ATLAS_ENDPOINTS.CAMERA_PURCHASE_PLATFORM(spaceId, deviceId),
      data
    );
    return response;
  } catch (err) {
    console.log('Error in adding purchase info of camera', err);
    throw err;
  }
};

export interface AddDeviceToSubscriptionPayload {
  device_ids: string[];
}

export async function addDeviceToSubscription(
  subscriptionId: string,
  payload: AddDeviceToSubscriptionPayload
) {
  try {
    const response = await homeSecurityPortalApi.put(
      ATLAS_ENDPOINTS.ADD_DEVICE_IN_SUBSCRIPTION(subscriptionId),
      payload
    );
    return response;
  } catch (error) {
    console.error('Error adding device to subscription:', error);
    throw error;
  }
}

export const DEVICE_PAIRING_STATUS = {
  INITIALIZED: 'Initialized',
  PROCESSED: 'Processed',
  FAILED: 'Failed',
  DELETED: 'Deleted',
  ACTIVATED: 'Activated',
  PAIRED: 'Paired'
};

export interface AuthenticateDevicePayload {
  name: string;
  pairing_status?: string;
}

export async function AuthenticateDevice(
  spaceId: string,
  deviceId: string,
  payload: AuthenticateDevicePayload
) {
  try {
    const response = await homeSecurityPortalApi.patch(
      ATLAS_ENDPOINTS.AUTHENTICATE_DEVICE(spaceId, deviceId),
      payload
    );
    return response;
  } catch (error) {
    console.error('Error authenticating device:', error);
    throw error;
  }
}
